import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import NoData from "../NoData/NoData";
import html2canvas from "html2canvas";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import TopicWiseSentimentBreakupChart from "./TopicWiseSentimentBreakupChart";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

class TopicWiseSentimentBreakup extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showGridLines: false,
        };
        this.chartEl = React.createRef();
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "topicWiseSentimentBreakup");
            });

        contextMenu.style("display", "block");
    };

    createNewFilter(chart) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        newFilter.extras = [{ key: "Sentiment", value: chart.sentiment }];

        let subtopicTitle = chart.category;
        let subtopicId = chart.subtopicId;

        if (chart.subtopicId === "others") {
            newFilter.subtopics = chart.subtopicIds;
            newFilter.topics = [];
        } else if (this.props.widget.chart_name === "subtopicWiseSentimentBreakup") {
            newFilter.subtopics = [subtopicId];
            newFilter.topics = [];
        } else {
            if (
                this.props.filters.topics &&
                this.props.filters.subtopics &&
                this.props.filters.topics.indexOf(subtopicId) === -1 &&
                this.props.filters.subtopics.indexOf(subtopicId) === -1
            ) {
                let chart_subtopics = this.props.allTopics
                    .filter((topic) => topic.topic_id === subtopicId)
                    .map((topic) => topic.subtopic_id)
                    .filter((item) => this.props.filters.subtopics.includes(item));

                newFilter.subtopics = chart_subtopics;
                newFilter.topics = [];
            } else {
                newFilter.subtopics = [];
                newFilter.topics = [subtopicId];
            }
        }
        // newFilter.extras = [{ key: "Sentiment", value: chart.series.name }];
        return newFilter;
    }

    handleContextMenuClick = (chart) => {
        let newFilter = this.createNewFilter(chart);
        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(chart) {
        let newFilter = this.createNewFilter(chart);

        this.props.handleDrilldownClick(newFilter);
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let { keys, positive, negative, neutral } = JSON.parse(JSON.stringify(this.props.data.csvRes));

        negative = negative.map((x) => x);
        negative.unshift("Negative");
        positive = positive.map((x) => x);
        positive.unshift("Positive");
        neutral = neutral.map((x) => x);
        neutral.unshift("Neutral");
        keys.unshift("Keys");
        let csvFmt = [keys, positive, neutral, negative];
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    {this.props.widget.chart_name === "topicWiseSentimentBreakup" ? (
                        <ChartName
                            name={this.props.widget.name}
                            info="Represents the volume of overall mentions per topic with actual total positive, negative and neutral contribution of mentions from each topic as well."
                        />
                    ) : (
                        <ChartName
                            name={this.props.widget.name}
                            info="Represents the volume of overall mentions per subtopic with actual total positive, negative and neutral contribution of mentions from each subtopic as well."
                        />
                    )}

                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />}
                        {!nodata && <CustomCheckBox checked={this.props.showLegendBar} onClick={this.props.changeShowLegendBar} label="Show Legends" />}
                        {!nodata && <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <TopicWiseSentimentBreakupChart
                            data={this.props.data}
                            showGridLines={this.props.showGridLines}
                            addContextMenuListener={this.addContextMenuListener}
                            showLabel={this.props.showLabel}
                            showLegend={this.props.showLegendBar}
                            widgetContainerRef={this.props.widgetContainerRef}
                            expandWidget={this.props.expandWidget}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        allTopics: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.topics : [],
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopicWiseSentimentBreakup);
